const zhCN = {
    crossmintPayButtonService: {
        CONNECTING: "连接中...",
        BUY: "使用Crossmint购买",
        BUY_WITH_ETH: "使用ETH购买",
        BUY_WITH_SOL: "使用SOL购买",
        BUY_WITH_CREDIT_CARD: "使用信用卡购买",
    },
};
export default zhCN;
